'use client'
import { cn } from "@/lib/utils";
import { forwardRef } from "react";

const Circle = forwardRef<
  HTMLDivElement,
  { className?: string; children?: React.ReactNode }
>(({ className, children }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "z-10 flex size-16 items-center justify-center rounded-full border border-gray-300 bg-white shadow-md",
        className
      )}
    >
      {children}
    </div>
  );
});

Circle.displayName = "Circle";

export default Circle;
